// extracted by mini-css-extract-plugin
export default {"Story":"Gallery_Story__GQWC4"};